function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 25.185l-9.406 5.986a1.5 1.5 0 0 1-2.26-1.63l2.559-10.234-5.854-5.854A1.5 1.5 0 0 1 1.95 10.9l8.402-.84 4.306-8.613a1.5 1.5 0 0 1 1.347-.83"
});

var SvgReviewStarHalf = function SvgReviewStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "d2579e7e0a130da20dc6f790fff54b77.svg";
export { SvgReviewStarHalf as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/review-star-half.svg
// module id = null
// module chunks = 